// components/PlanoSelector.tsx
import React from 'react';

type Plano = {
  amparo: boolean;
  odontogroup: boolean;
  topmed: boolean;
};

interface PlanoSelectorProps {
  hasPlanoOne: boolean;
  hasPlanoNow: boolean;
  planoOne: Plano;
  planoNow: Plano;
  onChangeOne: (key: keyof Plano) => void;
  onChangeNow: (key: keyof Plano) => void;
}

export const PlanoSelector: React.FC<PlanoSelectorProps> = ({
  hasPlanoOne,
  hasPlanoNow,
  planoOne,
  planoNow,
  onChangeOne,
  onChangeNow,
}) => {
  // Se não há planos para configurar, não renderiza nada
  if (!hasPlanoOne && !hasPlanoNow) {
    return null;
  }

  return (
    <div className="flex flex-row gap-10 p-6 justify-between">
      {/* Configuração Plano One */}
      {hasPlanoOne && (
        <div className="flex-1">
          <h6 className="text-xl font-extrabold text-blue-900 mb-4">
            Carga do Plano One:
          </h6>
          <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
            <div className="flex flex-col gap-3">
              <label className="flex items-center gap-3 cursor-pointer hover:bg-blue-100 p-2 rounded transition">
                <input
                  type="checkbox"
                  checked={planoOne.amparo}
                  onChange={() => onChangeOne('amparo')}
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                />
                <span className="text-sm font-medium text-gray-900">
                  📋 Envio Amparo
                </span>
                <span className="text-xs text-gray-500 ml-auto">
                  {planoOne.amparo ? '✅ Ativo' : '❌ Inativo'}
                </span>
              </label>

              <label className="flex items-center gap-3 cursor-pointer hover:bg-blue-100 p-2 rounded transition">
                <input
                  type="checkbox"
                  checked={planoOne.odontogroup}
                  onChange={() => onChangeOne('odontogroup')}
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                />
                <span className="text-sm font-medium text-gray-900">
                  🦷 Envio Odontogroup
                </span>
                <span className="text-xs text-gray-500 ml-auto">
                  {planoOne.odontogroup ? '✅ Ativo' : '❌ Inativo'}
                </span>
              </label>

              <label className="flex items-center gap-3 cursor-pointer hover:bg-blue-100 p-2 rounded transition">
                <input
                  type="checkbox"
                  checked={planoOne.topmed}
                  onChange={() => onChangeOne('topmed')}
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                />
                <span className="text-sm font-medium text-gray-900">
                  🏥 Envio TopMed
                </span>
                <span className="text-xs text-gray-500 ml-auto">
                  {planoOne.topmed ? '✅ Ativo' : '❌ Inativo'}
                </span>
              </label>
            </div>

            {/* Resumo do Plano One */}
            <div className="mt-3 pt-3 border-t border-blue-300">
              <p className="text-xs text-gray-600">
                <strong>Selecionados:</strong>{' '}
                {Object.values(planoOne).filter(Boolean).length} de 3 serviços
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Configuração Plano Now */}
      {hasPlanoNow && (
        <div className="flex-1">
          <h6 className="text-xl font-extrabold text-blue-900 mb-4">
            Carga do Plano Now:
          </h6>
          <div className="bg-green-50 p-4 rounded-lg border border-green-200">
            <div className="flex flex-col gap-3">
              <label className="flex items-center gap-3 cursor-pointer hover:bg-green-100 p-2 rounded transition">
                <input
                  type="checkbox"
                  checked={planoNow.topmed}
                  onChange={() => onChangeNow('topmed')}
                  className="w-4 h-4 text-green-600 bg-gray-100 border-gray-300 rounded focus:ring-green-500 focus:ring-2"
                />
                <span className="text-sm font-medium text-gray-900">
                  🏥 Envio TopMed
                </span>
                <span className="text-xs text-gray-500 ml-auto">
                  {planoNow.topmed ? '✅ Ativo' : '❌ Inativo'}
                </span>
              </label>

              <label className="flex items-center gap-3 cursor-pointer hover:bg-green-100 p-2 rounded transition">
                <input
                  type="checkbox"
                  checked={planoNow.odontogroup}
                  onChange={() => onChangeNow('odontogroup')}
                  className="w-4 h-4 text-green-600 bg-gray-100 border-gray-300 rounded focus:ring-green-500 focus:ring-2"
                />
                <span className="text-sm font-medium text-gray-900">
                  🦷 Envio Odontogroup
                </span>
                <span className="text-xs text-gray-500 ml-auto">
                  {planoNow.odontogroup ? '✅ Ativo' : '❌ Inativo'}
                </span>
              </label>

              <label className="flex items-center gap-3 cursor-pointer hover:bg-green-100 p-2 rounded transition">
                <input
                  type="checkbox"
                  checked={planoNow.amparo}
                  onChange={() => onChangeNow('amparo')}
                  className="w-4 h-4 text-green-600 bg-gray-100 border-gray-300 rounded focus:ring-green-500 focus:ring-2"
                />
                <span className="text-sm font-medium text-gray-900">
                  📋 Envio Amparo
                </span>
                <span className="text-xs text-gray-500 ml-auto">
                  {planoNow.amparo ? '✅ Ativo' : '❌ Inativo'}
                </span>
              </label>
            </div>

            {/* Resumo do Plano Now */}
            <div className="mt-3 pt-3 border-t border-green-300">
              <p className="text-xs text-gray-600">
                <strong>Selecionados:</strong>{' '}
                {Object.values(planoNow).filter(Boolean).length} de 3 serviços
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Resumo Geral */}
      {(hasPlanoOne || hasPlanoNow) && (
        <div className="w-64 bg-gray-50 p-4 rounded-lg border border-gray-200">
          <h6 className="text-lg font-bold text-gray-800 mb-3">
            📊 Resumo de Configuração
          </h6>

          <div className="space-y-2">
            {hasPlanoOne && (
              <div className="flex justify-between items-center p-2 bg-blue-100 rounded">
                <span className="text-sm font-medium">Plano One:</span>
                <span className="text-sm text-blue-600 font-bold">
                  {Object.values(planoOne).filter(Boolean).length}/3
                </span>
              </div>
            )}

            {hasPlanoNow && (
              <div className="flex justify-between items-center p-2 bg-green-100 rounded">
                <span className="text-sm font-medium">Plano Now:</span>
                <span className="text-sm text-green-600 font-bold">
                  {Object.values(planoNow).filter(Boolean).length}/3
                </span>
              </div>
            )}
          </div>

          <div className="mt-3 pt-3 border-t border-gray-300">
            <p className="text-xs text-gray-600 text-center">
              <strong>Total de integrações ativas:</strong>
              <br />
              {
                [
                  ...(hasPlanoOne ? Object.values(planoOne) : []),
                  ...(hasPlanoNow ? Object.values(planoNow) : []),
                ].filter(Boolean).length
              }{' '}
              serviços
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
